import React, { useState } from 'react';

interface SearchFunctionProps {
  placeholder?: string;
  onSearch: (query: string) => void;
}

export const SearchFunction: React.FC<SearchFunctionProps> = ({
  placeholder = "Search...",
  onSearch,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <div className="px-3 py-2 ">
      <input
        type="text"
        value={searchQuery}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="w-full h-[32px] px-2 border border-[#D9D9D9]  rounded-[4px] text-[14px] nunito-regular text-[#696969] focus:outline-none focus:ring-1 focus:ring-[#F15D18]"
      />
    </div>
  );
};